import { ReactNode } from 'react';
import i18n from 'i18n';
import { SortOrder } from 'antd/es/table/interface';

export const NOTIFICATION_FILTERS_KEY = 'COORDLY_NOTIFICATIONS_FILTERS_KEY';

type OptionsProps = {
  description: string;
  renderNode?: ReactNode;
  value: string;
}

export const getFilters = (
  notificationList: any[],
  key: string,
  render?: (value: any) => string,
  validation?: (index: any) => boolean,
  renderNode?: (value: any) => ReactNode,
) => {
  const types: any = {};
  const filterList: OptionsProps[] = [];
  notificationList?.forEach((file) => {
    if (file[key] === undefined || file[key] === null) {
      return;
    }
    const updateIndex = render ? render(file[key]) : file[key];

    if (
      types[updateIndex] === undefined &&
      (!validation || (validation && validation(updateIndex)))
    ) {
      types[updateIndex] = true;
      filterList.push({
        description: updateIndex.toString(),
        renderNode: renderNode && renderNode(updateIndex),
        value: updateIndex.toString()
      });
    }
  });

  return filterList;
}

export const getTextDate = () => [
  i18n.t('notification:page.dateToday'),
  i18n.t('notification:page.dateLast7'),
  i18n.t('notification:page.dateLast15'),
  i18n.t('notification:page.dateLast30'),
  i18n.t('notification:page.dateLast90'),
]

export const textDate = getTextDate();

export const filterDate = (
  notificationList: any[],
  key: string,
  render?: (value: any) => string[],
  validation?: (index: any) => boolean,
  renderNode?: (value: any) => React.ReactNode
) => {
  const types: any = {};
  const filterList: OptionsProps[] = [];
  notificationList?.forEach((file) => {
    if (file[key] === undefined || file[key] === null) {
      return;
    }
    const updateIndex = render ? render(file[key]) : file[key];

    if (
      types[updateIndex] === undefined &&
      (!validation || (validation && validation(updateIndex)))
    ) {
      types[updateIndex] = true;
      filterList.push({
        description: updateIndex.toString(),
        renderNode: renderNode && renderNode(updateIndex),
        value: updateIndex.toString()
      });
    }
  });

  return filterList;
}

type INotificationValidOrderKey = 'notifications' | 'obra' | 'users' | 'data';

const labelKeyMap: Record<INotificationValidOrderKey, string> = {
  notifications: 'notification:page.labelNotifications',
  obra: 'notification:page.labelObra',
  users: 'notification:page.labelUsers',
  data: 'notification:page.labelData',
}

export const getOrderTitle = (
  order: SortOrder,
  titleKey: INotificationValidOrderKey
) => {
  const title = i18n.t(labelKeyMap[titleKey]);

  if (order === null) {
    return i18n.t('notification:page.sortAsc', { title });
  }
  if (order === 'ascend') {
    return i18n.t('notification:page.sortDesc', { title });
  }
  return i18n.t('notification:page.sortDisable', { title });
}
